import type { PropType } from 'virtual-vue';
import type { TooltipArrowPosition } from './tooltip';

export const ARROW_POSITIONS: TooltipArrowPosition[] = [
  'top-center',
  'top-left',
  'top-right',
  'bottom-center',
  'bottom-left',
  'bottom-right',
  'left-center',
  'right-center',
];

export const props = {
  /**
   * 箭头位置（必填），决定 Tooltip 相对触发元素的展示方向
   */
  arrowPosition: {
    type: String as PropType<TooltipArrowPosition>,
    required: true as const,
    validator: (val: string) => ARROW_POSITIONS.includes(val as TooltipArrowPosition),
  },

  /**
   * 提示文案内容，最多显示 2 行
   */
  content: {
    type: String,
    required: true as const,
  },

  /**
   * 是否显示 Tooltip，支持 v-model:visible
   * @default false
   */
  visible: {
    type: Boolean,
    default: false,
  },

  /**
   * 是否显示关闭图标
   * @default false
   */
  closeIcon: {
    type: Boolean,
    default: false,
  },

  /**
   * 首次显示后自动消失时间（毫秒），0 不自动消失
   * @default 0
   */
  duration: {
    type: Number,
    default: 0,
  },

  /**
   * 组件挂载后是否默认展示
   * @default false
   */
  defaultVisible: {
    type: Boolean,
    default: false,
  },

  /**
   * 浮层与触发元素之间的间距（px）
   * @default 10
   */
  offset: {
    type: Number,
    default: 10,
  },

  /**
   * 箭头距触发元素边界的距离（px）
   * @default 16
   */
  arrowDistance: {
    type: Number,
    default: 16,
  },

  /**
   * 浮层距屏幕左右边界的最小距离（px）
   * @default 16
   */
  margin: {
    type: Number,
    default: 16,
  },
};
